<script lang="ts">
	import { onMount } from "svelte"
	import Header from "../../reusable/Header.svelte"
	import { MassUpdater } from "./MassUpdateController"
	import { Device, DeviceRPi } from "luxedo-data"
	import { openOverlay } from "overlay"
	import MassUpdateInput from "./MassUpdate_InputMany.svelte"
	import DeviceTable from "./MassUpdate_DeviceTable.svelte"
	import { RefreshIcon } from "luxedo-icons"

	let devices: Array<DeviceRPi> = $state([])
	let version: string = $state()

	MassUpdater.subscribe((ctx) => {
		devices = ctx.devices as any as Array<DeviceRPi>
		version = ctx.version
	})

	function openSelectInput() {
		openOverlay(MassUpdateInput, {
			classOverlay: "no-pad",
		})
	}

	function refresh() {
		MassUpdater.reset()
	}

	onMount(refresh)
</script>

<Header heading="Mass Update Devices" />
<main>
	{#if devices.length}
		<h3>Updating to v{version}...</h3>
		<div class="table-container">
			<DeviceTable {devices} {version} />
		</div>
	{:else}
		<div class="empty-indicator">No devices selected</div>
		<button onclick={openSelectInput}>Select Devices and Version</button>
	{/if}
	<button
		class="small only-icon"
		id="reset-button"
		title="Reset"
		onclick={refresh}
	>
		<RefreshIcon />
	</button>
</main>

<style>
	main {
		height: calc(100vh - var(--header-height));
		overflow: hidden;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	#reset-button {
		position: absolute;
		top: 0.5rem;
		right: 1rem;
	}

	.table-container {
		overflow: scroll;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 1rem 0;
		width: 100%;
	}
</style>
